import type from '../type'
export default {
    state: {
        num:1
    },
    mutations: {
        ADDNUM(state, n){
            state.num += n
        }
    },
    actions: {
        [type.ACTIONS.NUM]({ commit },n){
            commit('ADDNUM',n)
        }
    }
}